import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import { AppState } from "../../../store/app_state";

import Assets from "src/presentation/assets/img/assets";
import styled from "styled-components";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
} from "../../../../config/styles_const/styles_const";
import { entity } from "../../../../infra/api/rpc/api";
import {
  SelectItem,
  createSelectItem2,
} from "../../../../util/select_option_function";
import * as Validator from "../../../../util/validation";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import { BtnCorporateSmall2 } from "../../../common/atom/btn/btn_corporate_small";
import FormInput from "../../../common/atom/form/form_input";
import ErrorText from "../../../common/atom/text/error_text";
import HeadlineSmall from "../../../common/atom/text/headline_small";
import FormGroupSelectConnectRf from "../../../common/molecular/form_group/form_group_select_connect_rf";

const renderInputCustom = (field: any) => {
  const hasError = !!field.meta.error && !!field.meta.touched;

  return (
    <React.Fragment>
      <CustomInput
        {...field.input}
        type={field.type}
        placeholder={field.placeholder}
        autoComplete={`off`}
      />
      {hasError && (
        <div>
          <ErrorText>{field.meta.error}</ErrorText>
        </div>
      )}
    </React.Fragment>
  );
};

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IStateProps {
  initialValues: {
    q: string;
    occupationCategory: string;
    occupationParent: string;
    occupationSkillTag: string;
    singlePhaseTag: string;
    singleServiceClassificationTag: string;
    multiGyokaiTag: string;
    multiCXOTag: string;
    multiOverseaTag: string;
    multiOtherTag: string;
    occupationCategories: entity.IOccupationSkillTagCategoryItem[];
    occupationParents: entity.IOccupationSkillTag[];
    occupationChildren: entity.IOccupationSkillTag[];
    singlePhaseTags: entity.ISingleSkillTag[];
    singleServiceClassificationTags: entity.ISingleSkillTag[];
    multiGyokaiTags: entity.IMultiSkillTag[];
    multiCXOTags: entity.IMultiSkillTag[];
    multiOverseaTags: entity.IMultiSkillTag[];
    multiOtherTags: entity.IMultiSkillTag[];
    gender: string;
    age: string;
    workIntention: string;
    fullTimePossibility: string;
  };
}

interface IProps extends IStateProps {
  handleOccupationSkillTagCategoryChange: (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => void;
  handleOccupationSkillTagParentChange: (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => void;
  handleOccupationSkillTagChildChange: (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => void;
  onResetSearch: () => void;
}

interface IState {
  isFormOpen: boolean;
  isSelectOccupationCategory: boolean;
  isSelectOccupationParent: boolean;
  isSelectOccupationSkillTag: boolean;
  isSelectMultiGyokaiTag: boolean;
  isSelectSinglePhaseTag: boolean;
  isSelectSingleServiceClassificationTag: boolean;
  isSelectMultiCXOTag: boolean;
  isSelectMultiOverseaTag: boolean;
  isSelectMultiOtherTag: boolean;
  isSelectGender: boolean;
  isSelectAge: boolean;
  isSelectWorkIntention: boolean;
  isSelectFullTimePossibility: boolean;
}

export class ClientScoutCustomersNarrowDownForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);
    this.state = {
      isFormOpen: false,
      isSelectOccupationCategory: false,
      isSelectOccupationParent: false,
      isSelectOccupationSkillTag: false,
      isSelectMultiGyokaiTag: false,
      isSelectSinglePhaseTag: false,
      isSelectSingleServiceClassificationTag: false,
      isSelectMultiCXOTag: false,
      isSelectMultiOverseaTag: false,
      isSelectMultiOtherTag: false,
      isSelectGender: false,
      isSelectAge: false,
      isSelectWorkIntention: false,
      isSelectFullTimePossibility: false,
    };
  }

  public componentWillMount(): void {
    this.props.change("q", this.props.initialValues.q);
  }

  public render(): JSX.Element {
    const {
      handleOccupationSkillTagCategoryChange,
      handleOccupationSkillTagParentChange,
      handleOccupationSkillTagChildChange,
      form,
      initialValues,
      handleSubmit,
    } = this.props;

    const { isFormOpen } = this.state;

    return (
      <form name={form} onSubmit={handleSubmit}>
        <ClientScoutCustomersSearchFormWrapper>
          <FormWrapperTop>
            <SearchInputWrapper>
              <Field
                placeholder="フリーワード検索"
                name="q"
                component={renderInputCustom}
                type="text"
                validate={[Validator.query]}
              />
              <IconButton
                name="ClientScoutCustomerListSearchForm-submit"
                aria-label="Search"
                type="submit"
                icon={"'\f002'"}
              >
                検索する
              </IconButton>
            </SearchInputWrapper>
          </FormWrapperTop>
        </ClientScoutCustomersSearchFormWrapper>

        <ClientScoutCustomersNarrowDownFormWrapper>
          <FormTitleWrapper>
            <HeadlineSmall>条件で絞り込む</HeadlineSmall>
            <div
              style={{
                position: "relative",
                paddingRight: 30,
                cursor: "pointer",
                color: "#9A8C64",
                fontSize: 12,
                fontWeight: "bold",
              }}
              onClick={this.handleToggleIsFormOpen}
            >
              その他の条件を表示（業界、性別など）
              <img
                src={isFormOpen ? Assets.arrowDown : Assets.arrowRight}
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  width: 15,
                  height: 15,
                }}
              />
            </div>
          </FormTitleWrapper>
          <FormWrapper isOpen={true}>
            <FormInner>
              <FormFieldCustomWrapper>
                <Field
                  name="occupationCategory"
                  component={FormGroupSelectConnectRf}
                  type="text"
                  label={""}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    this.setState({
                      isSelectOccupationCategory: e.target.value !== "",
                    });

                    handleOccupationSkillTagCategoryChange(e);
                  }}
                  backgroundColor={
                    initialValues.occupationCategory ||
                    this.state.isSelectOccupationCategory
                      ? "#d7cdb1"
                      : undefined
                  }
                  fontWeight={
                    initialValues.occupationCategory ||
                    this.state.isSelectOccupationCategory
                      ? "bold"
                      : undefined
                  }
                >
                  {createSelectItem2(
                    initialValues.occupationCategories.map(
                      (item): SelectItem => {
                        return {
                          key: `${item.category}`,
                          value: item.name!,
                        };
                      }
                    ),
                    "職種を絞り込む"
                  )}
                </Field>
              </FormFieldCustomWrapper>
              <FormFieldCustomWrapper>
                <Field
                  name="occupationParent"
                  component={FormGroupSelectConnectRf}
                  type="text"
                  label={""}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    this.setState({
                      isSelectOccupationParent: e.target.value !== "",
                    });
                    handleOccupationSkillTagParentChange(e);
                  }}
                  disabled={initialValues.occupationParents.length === 0}
                  backgroundColor={
                    initialValues.occupationParent ||
                    this.state.isSelectOccupationParent
                      ? "#d7cdb1"
                      : undefined
                  }
                  fontWeight={
                    initialValues.occupationParent ||
                    this.state.isSelectOccupationParent
                      ? "bold"
                      : undefined
                  }
                >
                  {createSelectItem2(
                    initialValues.occupationParents.map((item): SelectItem => {
                      return {
                        key: `${item.id}`,
                        value: item.name!,
                      };
                    }),
                    "職種を細かく絞り込む"
                  )}
                </Field>
              </FormFieldCustomWrapper>
              <FormFieldCustomWrapper>
                <Field
                  name="occupationSkillTag"
                  component={FormGroupSelectConnectRf}
                  type="text"
                  label={""}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    this.setState({
                      isSelectOccupationSkillTag: e.target.value !== "",
                    });
                    handleOccupationSkillTagChildChange(e);
                  }}
                  disabled={initialValues.occupationChildren.length === 0}
                  backgroundColor={
                    initialValues.occupationSkillTag ||
                    this.state.isSelectOccupationSkillTag
                      ? "#d7cdb1"
                      : undefined
                  }
                  fontWeight={
                    initialValues.occupationSkillTag ||
                    this.state.isSelectOccupationSkillTag
                      ? "bold"
                      : undefined
                  }
                >
                  {createSelectItem2(
                    initialValues.occupationChildren.map((item): SelectItem => {
                      return {
                        key: `${item.id}`,
                        value: item.name!,
                      };
                    }),
                    "さらに職種を細かく絞り込む"
                  )}
                </Field>
              </FormFieldCustomWrapper>

              {isFormOpen && (
                <>
                  <FormFieldCustomWrapper>
                    <Field
                      name="multiGyokaiTag"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectMultiGyokaiTag: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.multiGyokaiTag ||
                        this.state.isSelectMultiGyokaiTag
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.multiGyokaiTag ||
                        this.state.isSelectMultiGyokaiTag
                          ? "bold"
                          : undefined
                      }
                    >
                      {createSelectItem2(
                        initialValues.multiGyokaiTags.map(
                          (item): SelectItem => {
                            return {
                              key: `${item.id}`,
                              value: item.name!,
                            };
                          }
                        ),
                        "業界"
                      )}
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="singlePhaseTag"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectSinglePhaseTag: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.singlePhaseTag ||
                        this.state.isSelectSinglePhaseTag
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.singlePhaseTag ||
                        this.state.isSelectSinglePhaseTag
                          ? "bold"
                          : undefined
                      }
                    >
                      {createSelectItem2(
                        initialValues.singlePhaseTags.map(
                          (item): SelectItem => {
                            return {
                              key: `${item.id}`,
                              value: item.name!,
                            };
                          }
                        ),
                        "事業フェーズ"
                      )}
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="singleServiceClassificationTag"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectSingleServiceClassificationTag:
                            e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.singleServiceClassificationTag ||
                        this.state.isSelectSingleServiceClassificationTag
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.singleServiceClassificationTag ||
                        this.state.isSelectSingleServiceClassificationTag
                          ? "bold"
                          : undefined
                      }
                    >
                      {createSelectItem2(
                        initialValues.singleServiceClassificationTags.map(
                          (item): SelectItem => {
                            return {
                              key: `${item.id}`,
                              value: item.name!,
                            };
                          }
                        ),
                        "事業区分"
                      )}
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="multiCXOTag"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectMultiCXOTag: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.multiCXOTag ||
                        this.state.isSelectMultiCXOTag
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.multiCXOTag ||
                        this.state.isSelectMultiCXOTag
                          ? "bold"
                          : undefined
                      }
                    >
                      {createSelectItem2(
                        initialValues.multiCXOTags.map((item): SelectItem => {
                          return {
                            key: `${item.id}`,
                            value: item.name!,
                          };
                        }),
                        "CxOの経験"
                      )}
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="multiOverseaTag"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectMultiOverseaTag: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.multiOverseaTag ||
                        this.state.isSelectMultiOverseaTag
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.multiOverseaTag ||
                        this.state.isSelectMultiOverseaTag
                          ? "bold"
                          : undefined
                      }
                    >
                      {createSelectItem2(
                        initialValues.multiOverseaTags.map(
                          (item): SelectItem => {
                            return {
                              key: `${item.id}`,
                              value: item.name!,
                            };
                          }
                        ),
                        "海外進出"
                      )}
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="multiOtherTag"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectMultiOtherTag: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.multiOtherTag ||
                        this.state.isSelectMultiOtherTag
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.multiOtherTag ||
                        this.state.isSelectMultiOtherTag
                          ? "bold"
                          : undefined
                      }
                    >
                      {createSelectItem2(
                        initialValues.multiOtherTags.map((item): SelectItem => {
                          return {
                            key: `${item.id}`,
                            value: item.name!,
                          };
                        }),
                        "その他の経験"
                      )}
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="gender"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectGender: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.gender || this.state.isSelectGender
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.gender || this.state.isSelectGender
                          ? "bold"
                          : undefined
                      }
                    >
                      <option value={""}>{"性別"}</option>
                      <option value={"1"}>{"男性"}</option>
                      <option value={"2"}>{"女性"}</option>
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="age"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectAge: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.age || this.state.isSelectAge
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.age || this.state.isSelectAge
                          ? "bold"
                          : undefined
                      }
                    >
                      <option value={""}>{"年代"}</option>
                      <option value={"1"}>{"～20代"}</option>
                      <option value={"2"}>{"30代"}</option>
                      <option value={"3"}>{"40代"}</option>
                      <option value={"4"}>{"50代"}</option>
                      <option value={"5"}>{"60代〜"}</option>
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper>
                    <Field
                      name="workIntention"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectWorkIntention: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.workIntention ||
                        this.state.isSelectWorkIntention
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.workIntention ||
                        this.state.isSelectWorkIntention
                          ? "bold"
                          : undefined
                      }
                    >
                      <option value={""}>{"稼働スタンス"}</option>
                      <option value={"1"}>{"アドバイザリーのみ"}</option>
                      <option value={"2"}>{"一部、手を動かすワークも可能"}</option>
                      <option value={"3"}>{"稼働内容に関しては要相談"}</option>
                    </Field>
                  </FormFieldCustomWrapper>

                  <FormFieldCustomWrapper style={{ width: 400 }}>
                    <Field
                      name="fullTimePossibility"
                      component={FormGroupSelectConnectRf}
                      type="text"
                      label={""}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.setState({
                          isSelectFullTimePossibility: e.target.value !== "",
                        });
                      }}
                      backgroundColor={
                        initialValues.fullTimePossibility ||
                        this.state.isSelectFullTimePossibility
                          ? "#d7cdb1"
                          : undefined
                      }
                      fontWeight={
                        initialValues.fullTimePossibility ||
                        this.state.isSelectFullTimePossibility
                          ? "bold"
                          : undefined
                      }
                    >
                      <option value={""}>
                        {"将来的な正社員、正規役員契約の可能性"}
                      </option>
                      <option value={"1"}>{"完全に可能性がゼロではない"}</option>
                      <option value={"2"}>{"完全に可能性なし"}</option>
                    </Field>
                  </FormFieldCustomWrapper>

                  <div style={{ width: 260 }} />
                </>
              )}

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <BtnCorporateSmall2
                  onClick={(e) => {
                    e.preventDefault();

                    this.props.change("occupationCategory", "");
                    this.setState({ isSelectOccupationCategory: false });
                    this.props.change("occupationParent", "");
                    this.setState({ isSelectOccupationParent: false });
                    this.props.change("occupationSkillTag", "");
                    this.setState({ isSelectOccupationSkillTag: false });
                    this.props.change("multiGyokaiTag", "");
                    this.setState({ isSelectMultiGyokaiTag: false });
                    this.props.change("singlePhaseTag", "");
                    this.setState({ isSelectSinglePhaseTag: false });
                    this.props.change("singleServiceClassificationTag", "");
                    this.setState({
                      isSelectSingleServiceClassificationTag: false,
                    });
                    this.props.change("multiCXOTag", "");
                    this.setState({ isSelectMultiCXOTag: false });
                    this.props.change("multiOverseaTag", "");
                    this.setState({ isSelectMultiOverseaTag: false });
                    this.props.change("multiOtherTag", "");
                    this.setState({ isSelectMultiOtherTag: false });
                    this.props.change("gender", "");
                    this.setState({ isSelectGender: false });
                    this.props.change("age", "");
                    this.setState({ isSelectAge: false });
                    this.props.change("workIntention", "");
                    this.setState({ isSelectWorkIntention: false });
                    this.props.change("fullTimePossibility", "");
                    this.setState({ isSelectFullTimePossibility: false });

                    this.props.onResetSearch();
                  }}
                >
                  条件をリセットする
                </BtnCorporateSmall2>

                <BtnCorporateSmall2 type="submit">
                  この条件で絞り込む
                </BtnCorporateSmall2>
              </div>
            </FormInner>
          </FormWrapper>
        </ClientScoutCustomersNarrowDownFormWrapper>
      </form>
    );
  }

  private handleToggleIsFormOpen = () => {
    this.setState({
      isFormOpen: !this.state.isFormOpen,
    });
  };
}

const mapStateToProps = (state: AppState, initialProps: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm<{}, IProps>({
  validate,
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientScoutCustomersNarrowDownForm)
);

const ClientScoutCustomersNarrowDownFormWrapper = styled.div`
  border-radius: ${ConstBorderRound.CornerRoundAll};
  margin-bottom: 30px;
`;

const FormTitleWrapper = styled.div`
  height: 60px;
  padding: 15px 20px;
  background: #fbfbfb;
  border-bottom: 1px solid ${ConstColor.LightGray};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ToggleIcon = styled(HeadlineSmall)`
  :hover {
    cursor: pointer;
  }
`;

const FormWrapper = styled.div<{ isOpen: boolean }>`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  padding: 30px 30px 15px 30px;
  background: ${ConstColor.BgGray};
`;

const FormInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
`;

const FormFieldCustomWrapper = styled.div`
  width: 260px;
  margin-bottom: 15px;
`;

const SearchInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const IconButton = styled(BtnCorporateLarge)`
  position: relative;
  height: 36px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 24px;
  background: linear-gradient(180deg, #9a8c64 0%, #827654 100%);
  border-radius: ${ConstBorderRound.CornerRoundAll};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    height: 47px;
  }
  ::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    content: "";
    transition: all 0.3s ease;
    mix-blend-mode: overlay;
  }
  &:hover::after {
    background: #a5a293;
  }
`;

const CustomInput = styled(FormInput)`
    height: 100%;
    // border: 1px solid ${ConstColor.Base};
    border: none
    border-radius: ${ConstBorderRound.CornerRoundLeftTopLeftBottom};
    &:focus {
        border: none;
    }
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
    
    }
`;

const ClientScoutCustomersSearchFormWrapper = styled.div`
  margin-bottom: 40px;
`;

const FormWrapperTop = styled.div`
  padding: 5px;

  background: ${ConstColor.White};

  border: 1px solid ${ConstColor.White};
  box-shadow: 0px 0px 10px rgba(199, 199, 199, 0.2);
  border-radius: 10px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customers/client_scout_customers_narrow_down_form.tsx